import api from './api'

export interface PayrollRun {
  id: number
  periodStart: string
  periodEnd: string
  payrollMonth: number
  payrollYear: number
  status: string
}

export interface Employee {
  id: number
  firstName: string
  lastName: string
  employeeNumber: string
  department?: string
  position?: string
}

export interface PayslipLineItem {
  id: number
  itemType: 'earning' | 'deduction' | 'allowance' | 'tax' | 'benefit'
  itemName: string
  amount: number
  currency: 'USD' | 'CDF'
  isTaxable: boolean
}

export interface Payslip {
  id: number
  employee: Employee
  payrollRun: PayrollRun
  baseSalary: number
  salaryCurrency: 'USD' | 'CDF'
  workingDays: number
  daysWorked: number
  grossSalary: number
  allowancesTotal: number
  overtimeAmount: number
  bonusAmount: number
  totalEarnings: number
  incomeTax: number
  socialSecurity: number
  loanDeductions: number
  otherDeductions: number
  totalDeductions: number
  netPay: number
  netPayUsd: number | null
  netPayCdf: number | null
  leaveDaysTaken: number
  leaveDeduction: number
  createdAt: string
  lineItems: PayslipLineItem[]
}

export interface PayslipsResponse {
  payslips: Payslip[]
  pagination: {
    page: number
    limit: number
    total: number
    totalPages: number
    hasNext: boolean
    hasPrev: boolean
  }
}

export const payslipService = {
  // Get employee's own payslips
  async getMyPayslips(params?: { page?: number; limit?: number }) {
    const response = await api.get('/payroll/my-payslips', { params })
    return response.data as { success: boolean; data: PayslipsResponse }
  },

    // Get all payslips (admin/HR only)
  async getAllPayslips(params?: { page?: number; limit?: number }) {
    const response = await api.get('/payroll/payslips', { params })
    return response.data as { success: boolean; data: PayslipsResponse }
  },

  // Download payslip PDF
  async downloadPayslipPDF(payslipId: number) {
    const response = await api.get(`/payroll/payslips/${payslipId}/pdf`, {
      responseType: 'blob'
    })
    return response.data as Blob
  }
}